<template>
    <div class="bizcomp-fund-market white">
        <comp-title :title="title" />
        <div class="fund-market">
            <el-row class="fund-filter">
                <el-col v-if="isPublic" :span="24" class="btn-fund">
                    基金类型：
                    <el-radio-group v-model="activeType" size="mini">
                        <el-radio-button
                            v-for="item in fundTypes"
                            :key="item.val"
                            :label="item.val"
                        >
                            {{ item.text }}
                        </el-radio-button>
                    </el-radio-group>
                </el-col>
                <el-col v-else :span="24" class="btn-fund">
                    基金策略类型：
                    <el-radio-group v-model="strategyType" size="mini">
                        <el-radio-button label="">全部</el-radio-button>
                        <el-radio-button
                            v-for="item in strategyTypeList"
                            :key="item.strategycode"
                            :label="item.strategycode"
                        >
                            {{ item.strategyname }}
                        </el-radio-button>
                    </el-radio-group>
                </el-col>
                <el-col v-if="isPublic" :span="24" class="btn-fund">
                    基金风险：
                    <el-radio-group v-model="fundRisk" size="mini">
                        <el-radio-button label="">全部</el-radio-button>
                        <el-radio-button
                            v-for="risk in riskList"
                            :key="risk.subitem"
                            :label="risk.subitem"
                        >
                            {{ risk.subitemname }}风险
                        </el-radio-button>
                    </el-radio-group>
                </el-col>
                <el-col v-else :span="24" class="btn-fund">
                    基金风险：
                    <el-radio-group v-model="ismatch" size="mini">
                        <el-radio-button label="0">全部</el-radio-button>
                        <el-radio-button label="1">只看风险匹配</el-radio-button>
                    </el-radio-group>
                </el-col>
                <el-col :span="24" class="btn-search">
                    查询条件：
                    <span v-for="tag in dynamicTags" :key="tag" style="display: inline-block">
                        <el-tag
                            v-if="tag"
                            closable
                            :disable-transitions="false"
                            v-on:close="handleClose(tag)"
                        >
                            {{ tag }}
                        </el-tag>
                    </span>
                    <el-autocomplete
                        v-model="searchText"
                        popper-class="my-autocomplete"
                        placeholder="请输入查询基金名称或基金代码"
                        class="input-search"
                        :popper-append-to-body="false"
                        size="small"
                        :fetch-suggestions="querySearchAsync"
                        v-on:select="handleSelect"
                    >
                        <template slot-scope="{ item }">
                            <div class="name">
                                {{ item.value }}
                            </div>
                        </template>
                    </el-autocomplete>
                    <el-button
                        class="btn-search-icon"
                        icon="el-icon-search"
                        type="yellow"
                        size="small"
                        v-on:click="searchFund"
                    />
                </el-col>
                <el-col :span="24" class="btn-fund">
                    共有
                    <span class="red">{{ allPage }}</span>
                    条基金&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;排序：
                    <el-row v-model="sortVal" size="small" class="sort-btn">
                        <!--<el-button size="small" :type="sortVal==='sales'?'primary':''" @click="getVal('sales')">按销量<i :class="sort.sales?icond:iconu" aria-hidden="true"></i></el-button>-->
                        <el-button
                            size="small"
                            :type="sortVal === 'grow' ? 'yellow' : ''"
                            v-on:click="getVal('grow')"
                        >
                            按涨跌幅
                            <i aria-hidden="true" :class="sort.grow.up ? icond : iconu" />
                        </el-button>
                        <el-button
                            size="small"
                            :type="sortVal === 'incomeAll' ? 'yellow' : ''"
                            v-on:click="getVal('incomeAll')"
                        >
                            按成立以来收益
                            <i aria-hidden="true" :class="sort.incomeAll.up ? icond : iconu" />
                        </el-button>
                        <el-button
                            size="small"
                            :type="sortVal === 'income' ? 'yellow' : ''"
                            v-on:click="getVal('income')"
                        >
                            按今年以来收益
                            <i aria-hidden="true" :class="sort.income.up ? icond : iconu" />
                        </el-button>
                        <!--                        <el-button size="small" :type="sortVal==='risk'?'yellow':''" v-on:click="getVal('risk')">
                            按风险<i
                                :class="sort.risk.up?icond:iconu"
                            />
                        </el-button> -->
                        <el-select
                            v-show="sortVal ? sort[sortVal].id === 'dayfloatprofit' : false"
                            v-model="growValue"
                            class="grow-class"
                            size="small"
                            placeholder="请选择区间"
                        >
                            <el-option
                                v-for="item in growArea"
                                :key="item.value"
                                :label="item.label"
                                :value="item.value"
                            ></el-option>
                        </el-select>
                    </el-row>
                </el-col>
            </el-row>
            <fund-risk-filter v-if="isPublic" :qryall="ismatch" v-on:qry-change="qryChange" />
            <fund-list
                :has-load="hasLoad"
                :fund-info="fund"
                :tab-index="activeType"
                :all-page="allPage"
                :page="pageoffset"
                v-on:new-fund="newFund"
                v-on:fund-continue="fundBuy"
            />
        </div>
        <fund-sdx-dialog
            :fund="sdxFundInfo"
            :sdx-dialog-visible="sdxDialogVisible"
            v-on:dialogClosed="sdxDialogClose"
            v-on:dialogContinue="sdxDialogContinue"
        ></fund-sdx-dialog>
    </div>
</template>

<script>
import mixin from "@/assets/js/mixin";
import fundList from "@/components/fund/dcFundList";
import fundRiskFilter from "@/components/form/fundRiskFilter";
import fundApi from "@/api/fund";
import fundSdxDialog from "@/components/form/fundSdxDialog";
import { getRiskFilter } from "@/util";

export default {
    name: "FundMarket",
    components: {
        fundList,
        fundRiskFilter,
        fundSdxDialog
    },
    mixins: [mixin],
    data() {
        return {
            ismatch: getRiskFilter(), // 是否只看风险匹配
            searchText: "", // 搜索文本内容
            fund: [], // 基金信息
            queryFind: null, // 定时器
            allPage: "0", // 所有数据条数
            pagecount: 10, // 分页条数
            pageoffset: 1, // 起始页
            url: "", // 当前页面路由命名
            isPublic: true, // 是否公募
            activeType: "", // 基金类型
            hasLoad: false, // 是否已经查询数据
            sdxFundInfo: {},
            sdxDialogVisible: false,
            fundTypes: [],
            iconu: "el-icon-upload2",
            icond: "el-icon-download",
            sortVal: "", // 排序字段
            lastSortVal: "", // 上次排序字段
            dynamicTags: [], // 筛选条件
            riskList: [],
            fundclass: "", // 公私募标记
            strategyType: "", // 基金策略类型
            strategyTypeList: [], // 策略类型数据
            fundRisk: "", // 基金风险
            sort: {
                incomeAll: {
                    id: "allud",
                    up: true
                },
                grow: {
                    id: "dayfloatprofit",
                    up: true
                },
                income: {
                    id: "thisyear1ud",
                    up: true
                },
                risk: {
                    id: "8",
                    up: false
                }
            },
            growArea: [
                {
                    value: "dayfloatprofit",
                    label: "日涨跌幅"
                },
                {
                    value: "month1ud",
                    label: "近一月涨跌幅"
                },
                {
                    value: "month3ud",
                    label: "近三月涨跌幅"
                },
                {
                    value: "month6ud",
                    label: "近六月涨跌幅"
                },
                {
                    value: "year1ud",
                    label: "近一年涨跌幅"
                },
                {
                    value: "year3ud",
                    label: "近三年涨跌幅"
                },
                {
                    value: "year5ud",
                    label: "近五年涨跌幅"
                },
                {
                    value: "allud",
                    label: "成立以来"
                }
            ],
            growValue: ""
        };
    },
    watch: {
        activeType(val, from) {
            if (!val) {
                this.$set(this.dynamicTags, 0, "");
            } else {
                const _x = this.fundTypes.find((risk) => {
                    return risk.val === val;
                });
                this.$set(this.dynamicTags, 0, _x.text);
            }
            this.pageoffset = 1;
            this.doAction();
        },
        fundRisk(val, from) {
            if (!val) {
                const _x = this.riskList.find((risk) => {
                    return risk.subitem === from;
                });
                this.dynamicTags.splice(this.dynamicTags.indexOf(_x.subitemname), 1);
            } else {
                const _x = this.riskList.find((risk) => {
                    return risk.subitem === val;
                });
                this.$set(this.dynamicTags, 1, _x.subitemname + "风险");
            }
            this.pageoffset = 1;
            this.doAction();
        },
        growValue(val) {
            if (val) {
                this.doAction();
            }
        },
        sortVal(val) {
            if (this.sort[val].id !== "dayfloatprofit") {
                this.growValue = "";
            }
        },
        strategyType(val, from) {
            if (!val) {
                this.$set(this.dynamicTags, 0, "");
            } else {
                const _x = this.strategyTypeList.find((strategy) => {
                    return strategy.strategycode == val;
                });
                this.$set(this.dynamicTags, 0, _x.strategyname);
            }
            this.pageoffset = 1;
            this.doAction();
        },
        ismatch(val, from) {
            if (this.isPublic) {
                return;
            }
            if (!val) {
                this.$set(this.dynamicTags, 1, "");
            } else {
                const text = val == "0" ? "" : "只看风险匹配";
                this.$set(this.dynamicTags, 1, text);
            }
            this.pageoffset = 1;
            this.doAction();
        }
    },
    async created() {
        this.$store.commit("updateLoadFund", false);
        this.url = this.$route.name;
        this.isPublic = this.$route.name == "fund" || this.$route.name == "glist";
        if (this.isPublic) {
            const info = this.$cache.getUser();
            if (info.professionflag == "0") {
                this.ismatch = info.ismatch || "1";
            }
            this.riskList = this.$cache.getDict("110143");
        } else {
            this.getFundStrategyType();
        }
        this.riskList = this.$cache.getDict("110143");
        this.fundclass = this.$util.getFundClass();
        this.doAction();
        let fundclassList =
            (this.$cache.getParamValue("fund_market") &&
                this.$cache.getParamValue("fund_market").fundshowtypes) ||
            [];
        // 判断脚本是否有热销基金这项
        let hasTargetItem = fundclassList.some((item) => item.subitem === "47223");
        // 处理基金超市展示的列表项
        const convertedApiTabs = fundclassList.map((item) => ({
            val: item.subitem != "47223" ? item.subitem : "hot",
            text: item.subitemname
        }));
        if (hasTargetItem) {
            const res = await fundApi.getFundLists({
                tagids: "47223",
                pagesize: 10,
                pagenum: 1
            });
            // 如果没有热销基金 不展示此tab
            if (res.data.list.length == 0) {
                hasTargetItem = false;
                convertedApiTabs.shift();
            }
        }
        this.fundTypes =
            this.fundclass == "1"
                ? JSON.parse(JSON.stringify(this.$util.getConfig().privateFundTypes))
                : convertedApiTabs;
        this.activeType = this.fundclass == "1" ? "999" : hasTargetItem ? "hot" : "999";
        this.fundTypes.forEach((item) => {
            if (!item.val) {
                item.val = "999";
            }
        });
    },
    mounted() {
        this.getVal("grow");
    },
    methods: {
        // 处理基金适当性信息
        fundBuy(way, val) {
            this.sdxFundInfo = {};
            // 普通购买/定投
            if (way === "20,22") {
                val._url = "buyfund";
                val.proto = "buy";
            } else if (way === "59") {
                val._url = "generalbuy";
                val.proto = "plan";
            }
            this.$util.fundRiskCheck(this, val, (res) => {
                if (res) {
                    this.$util.getSdxProtocol(res, (data) => {
                        if (data) {
                            const _x = Object.assign({}, data, { way: way });
                            this.sdxFundInfo = _x;
                            this.sdxDialogVisible = true;
                        }
                    });
                }
            });
        },
        // 获取排序数据
        getVal(val) {
            this.sortVal = val;
            if (this.sortVal === this.lastSortVal) {
                this.sort[val].up = !this.sort[val].up;
            } else {
                this.lastSortVal = this.sortVal;
            }
            this.doAction();
        },
        sdxDialogClose() {
            this.sdxDialogVisible = false;
        },
        sdxDialogContinue() {
            this.sdxDialogVisible = false;
            sessionStorage.setItem(this.sdxFundInfo._url, JSON.stringify(this.sdxFundInfo));
            this.$router.push({
                name: this.sdxFundInfo._url,
                query: { fundcode: this.sdxFundInfo.fundcode }
            });
        },
        // 改变风险过滤规则
        qryChange(val) {
            this.ismatch = val;
            this.pageoffset = 1;
            this.doAction();
        },
        // 搜索基金
        searchFund() {
            this.pageoffset = 1;
            this.doAction(this.searchText);
        },
        // 获取策略类型数据
        async getFundStrategyType() {
            const res = await fundApi.getFundStrategyType();
            this.strategyTypeList = res.data || [];
        },
        // 获取下拉列表数据
        querySearchAsync(queryString, cb) {
            this.doAction(queryString, (res) => {
                let _cbArr = [];
                res.forEach((item, index) => {
                    let _x = {};
                    _x.value = item.fundname + "(" + item.fundcode + ")";
                    _x.id = item.fundcode;
                    _x.index = index;
                    _cbArr.push(_x);
                });
                cb(_cbArr);
            });
        },
        // 选中建议项
        handleSelect() {
            if (this.searchText.indexOf("(") != -1) {
                this.searchText = this.searchText.slice(0, this.searchText.indexOf("("));
            }
            // this.pageoffset = 1;
            // this.doAction();
        },
        // 获取新一页数据
        newFund(val) {
            this.pageoffset = Number(val);
            this.doAction();
        },
        // 获取基金信息
        async getFund(val, cb) {
            const _this = this;
            const exType = ["999", "0", "zghr", "hot"];
            const _x = {
                tagids: this.activeType === "hot" ? "47223" : "",
                fundshowtype: exType.includes(this.activeType) ? "" : this.activeType,
                ismatch: this.ismatch,
                strategylevel1: this.strategyType,
                risklevel: this.fundRisk,
                orderfield: this.growValue
                    ? this.growValue
                    : this.sortVal
                    ? this.sort[this.sortVal].id
                    : "",
                isasc: this.sortVal ? (this.sort[this.sortVal].up ? "0" : "1") : "",
                valuagrbuystate: this.url === "glist" ? "1" : "",
                keyword: val || (this.searchText ? this.searchText : ""),
                pagesize: cb ? 20 : this.pagecount,
                pagenum: val ? 1 : this.pageoffset,
                tradingmethod: this.$util.getConfig().systemtype,
                mrfflag: this.activeType === "zghr" ? "1" : undefined,
                fundclass: this.fundclass
            };
            const res = await fundApi.getFundLists(_x);
            this.hasLoad = true;
            this.$store.commit("updateLoadFund", true);
            if (res.data) {
                if (cb) {
                    cb.call(_this, res.data.list);
                } else {
                    if (this.pageoffset == 1) {
                        this.allPage = "0";
                    }
                    _this.fund = res.data.list;
                    if (this.activeType === "hot" && !_this.fund.length) {
                        _this.activeType = "999";
                        _this.fundTypes.shift();
                        _this.doAction();
                    }
                    if (_this.isPublic) {
                        // 记录过滤状态
                        const info = _this.$cache.getUser();
                        info.ismatch = _this.ismatch;
                        _this.$store.dispatch("setInfo", info);
                    }
                    _this.allPage = res.data.total.toString();
                }
            }
        },
        // 对基金频繁查询请求做处理
        doAction(val, cb) {
            const _this = this;
            if (cb) {
                val = this.$util.filterCode(val);
                this.searchText = val;
                if (val.length < 1) {
                    cb.call(this, []);
                    return false;
                }
            }
            clearTimeout(this.queryFind);
            this.queryFind = setTimeout(function () {
                _this.getFund(val, cb);
            }, 500);
        },
        // 切换类型tab
        handleClick(target) {
            this.pageoffset = 1;
            this.doAction();
        },
        // 搜索选项关闭处理
        handleClose(val) {
            if (this.isPublic) {
                if (val.toString().indexOf("风险") > -1) {
                    this.fundRisk = "";
                } else {
                    this.activeType = "";
                }
            } else {
                if (val == "只看风险匹配") {
                    this.ismatch = "0";
                } else {
                    this.strategyType = "";
                }
            }
        }
    }
};
</script>

<style lang="scss">
@import "../../assets/css/varibles";
.white {
    background: #ffffff;
    border: 1px solid #f1f1f1;
    margin-bottom: 20px;
    padding-bottom: 20px;
}
.fund-title {
    display: flex;
    padding: 20px 0;
    align-items: center;
    justify-content: space-between;
    .fund-ic {
        width: 30px;
        height: 30px;
        margin-right: 12px;
        margin-top: 3px;
    }
    .fund-search {
        .input-search {
            width: 400px;
            vertical-align: middle;
            .search-icon {
                margin: 0 5px;
                height: 40px;
                color: #666666;
            }
            .el-input__inner {
                height: 40px;
                line-height: 40px;
                border-bottom-right-radius: 0;
                border-top-right-radius: 0;
            }
            .el-input-group__append {
                background-color: var(--color-primary);
                color: $text-color6;
                font-size: $f20;
                border-color: var(--color-primary);
                padding: 0 10px;
            }
        }
        .fund-total {
            margin-left: 30px;
            margin-right: 15px;
            font-size: 18px;
            line-height: 40px;
            font-weight: normal;
            color: var(--color-primary);
        }
    }
}
.type-bg {
    background: #edf5fc;
}
.fund-type {
    padding: 0 20px;
    height: 60px;
    opacity: 1;
    border-bottom-left-radius: 30px;
    border-bottom-right-radius: 30px;
    background: linear-gradient(90deg, #1e3b7b -1%, #e40c1a 101%);
    .el-tabs__header {
        margin: 0;
    }
    .el-tabs__nav-wrap:after {
        background: transparent;
        height: 1px;
    }
    .el-tabs__nav-scroll {
        line-height: 60px;
        padding: 0 20px;
        .el-tabs__active-bar {
            height: 3px;
            background: var(--color-primary);
        }
        .el-tabs__item {
            padding: 0 15px;
            font-size: $f20;
            font-weight: normal;
            color: rgba(255, 255, 255, 0.8);
            text-align: center;
            min-width: 82px;
            &.is-active {
                min-width: 88px;
                font-size: $f24;
                font-weight: 500;
                color: #ffffff;
            }
            .el-badge__content.is-fixed {
                top: 10px;
                right: 1px;
            }
        }
    }
    .el-tabs__content {
        padding: 0 0 20px;
        .fund-offset .cell {
            padding: 0 10px 0 20px;
        }
        .fund-arr {
            padding: 0 20px;
            .cell {
                padding: 0;
            }
        }
    }
}
.bizcomp-fund-market .risk-filter-text {
    border: none;
    margin: 0;
}
</style>
